import { useRef as M, useContext as Q, useEffect as R, useCallback as a } from "react";
import b from "immutability-helper";
import "../../components/Breadcrumbs/index.js";
import "../../components/Button/index.js";
import "react/jsx-runtime";
import "classnames";
import "reactjs-popup";
import { ThemeContext as U } from "../../components/ThemeContext/index.js";
import "../../components/Modal/index.js";
import "../../fields/FieldContainer/index.js";
import "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import "../../fields/DateInput/index.js";
import "date-fns";
import "react-i18next";
import "../../index-YV3Z4nmr.js";
import "react-dropzone";
import "../../fields/Input/index.js";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import "../../fields/Switcher/index.js";
import "../../fields/Textarea/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import { recalculateNumbers as W, calculateTotalValues as X, calculateProductValues as d } from "../../helpers/productsCalcFunctions.js";
import { mapTotalForCalc as Y, mapProductToData as Z } from "../../helpers/mapProductsToFilling.js";
import w from "../../helpers/nanoid.js";
import "../../components/Tooltip/index.js";
const wt = ({
  columnIds: P,
  totalIds: h,
  showTotalRow: D,
  products: r,
  productsTotal: m,
  customProductsIds: u = [],
  onChangeTable: E,
  externalValues: p,
  excludeVAT: e = !1
}) => {
  const g = M(p), { currencies: j, lang: F } = Q(U), f = j[F].code, S = D;
  R(() => {
    !g.current || !p || (Object.keys(p).forEach((t) => {
      p[t] !== g.current[t] && O(t, p[t]);
    }), g.current = p);
  }, [p]);
  const v = a((t) => t.map((i) => ({ ...i, ...p })), [p]), c = a((t, i, n, s) => {
    const o = W(t), C = X(
      v(o),
      Y(i, h, D),
      f,
      n
    );
    E(o, C, s ?? u, n);
  }, [f, h, D, E, v, u]), N = a((t, i) => {
    const n = i.map(
      (s) => d(
        { ...Z(s, P), id: s.id, number: "1", count: "1", markdownCount: "1" },
        f
      )
    );
    return c(b(r, { $splice: [[t + 1, 0, ...n]] }), m, e), n;
  }, [r, m, e, P, f, c]), q = a((t, i) => {
    const n = i.map((o) => {
      const C = P.reduce((L, $) => ({ ...L, [$]: o[$] ?? "" }), {});
      return d({ ...C, id: o.id ?? w(12), number: "1", count: C.count || "1", markdownCount: C.markdownCount || "1" }, f);
    }), s = b(r, { $splice: [[t + 1, 0, ...n]] });
    return c(s, m, e, [...u, ...n.map((o) => o.id)]), n;
  }, [r, m, e, u, P, f, c]), z = a((t) => {
    c(r.filter((i) => !t.includes(i.id)), m, e);
  }, [r, m, e, c]), B = a((t) => {
    const i = r.sort((n, s) => t.indexOf(n.id) - t.indexOf(s.id));
    c(i, m, e);
  }, [r, m, e, c]), G = a((t) => {
    const i = P.length === 1 && S ? 2 : P.length, n = { id: w(12), type: "title", name: "", colspan: i + "" };
    return c(b(r, { $splice: [[t + 1, 0, n]] }), m, e), n;
  }, [r, m, e, S, c]), H = a((t, i, n) => {
    c(
      r.map((s) => {
        if (s.id !== t)
          return s;
        const o = { ...s, [i]: n };
        return i === "discountPercent" && o.discountCost && (o.discountCost = ""), i === "discountCost" && o.discountPercent && (o.discountPercent = ""), d(o, f);
      }),
      m,
      e
    );
  }, [r, m, e, f, c]), O = a((t, i) => {
    const n = r.map((s) => {
      const o = { ...s, [t]: i };
      return t === "discountPercent" && o.discountCost && (o.discountCost = ""), t === "discountCost" && o.discountPercent && (o.discountPercent = ""), d(o, f);
    });
    c(n, m, e);
  }, [r, m, e, f, c]), J = a((t, i) => {
    const n = { ...m, [t]: i };
    t === "totalDiscountPercent" && n.totalDiscountCost && (n.totalDiscountCost = ""), t === "totalDiscountCost" && n.totalDiscountPercent && (n.totalDiscountPercent = ""), c(r, n, e);
  }, [r, m, e, c]), K = a((t) => {
    c(r, m, t);
  }, [r, m, c]);
  return {
    addProducts: N,
    addCustomProducts: q,
    removeProducts: z,
    sortProducts: B,
    addSection: G,
    changeCell: H,
    applyToAll: O,
    changeTotalCell: J,
    setExcludeVat: K
  };
};
export {
  wt as useProductSelection
};
